export const sources = {
	avif: "__VITE_ASSET__CkFm4rF7__ 139w",
	webp: "__VITE_ASSET__Br96eCYF__ 139w"
};
export const img = {
	src: "__VITE_ASSET__CU9pi6Uw__",
	w: 139,
	h: 457
};
export default {
	sources: sources,
	img: img
};
